var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Modal',{ref:"modal",attrs:{"title":_vm.$t('G.LIT_Contact'),"hide-ok-btn":"","cancel-title":_vm.$t('G.LIT_Close'),"size":"lg"}},[_c('ContactContent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }